export function initializeHomeProductsReadmore() {
  const button = document.querySelector('.js-home-product-more');
  if (!button) return;

  const grid = document.getElementById('home-products-grid');
  if (!grid) return;

  const MORE_TEXT = '...続きを読む';
  const CLOSE_TEXT = '閉じる';

  const textSpan = button.querySelector('.m-home-product__more-text');
  const setButtonText = (isExpanded) => {
    if (!textSpan) return;
    const targetText = isExpanded ? CLOSE_TEXT : MORE_TEXT;
    // 先頭のテキストノードを差し替え（SVGは残す）
    const textNode = Array.from(textSpan.childNodes).find(
      (n) => n.nodeType === Node.TEXT_NODE,
    );
    if (textNode) {
      textNode.nodeValue = targetText + ' ';
    } else {
      textSpan.insertBefore(
        document.createTextNode(targetText + ' '),
        textSpan.firstChild,
      );
    }
  };

  const collapseToInitial = () => {
    // 閉じる前の高さを取得し、縮んだ分だけ上方向にスクロール補正する
    const prevHeight = grid.offsetHeight;
    const cards = grid.querySelectorAll('.m-home-product-card');
    cards.forEach((card, index) => {
      if (index >= 4) {
        card.setAttribute('hidden', '');
        card.classList.add('m-home-product-card--collapsed');
      } else {
        card.removeAttribute('hidden');
        card.classList.remove('m-home-product-card--collapsed');
      }
    });
    button.setAttribute('aria-expanded', 'false');
    setButtonText(false);

    // レイアウト反映後に高さ差分を計測してスクロール補正
    requestAnimationFrame(() => {
      const nextHeight = grid.offsetHeight;
      const diff = prevHeight - nextHeight;
      if (diff > 0) {
        // 即時スクロールで視点を維持（スムースにしない）
        window.scrollBy({ top: -diff, left: 0, behavior: 'auto' });
      }
    });
  };

  const expandAll = () => {
    const hiddenCards = grid.querySelectorAll(
      '.m-home-product-card[hidden], .m-home-product-card--collapsed',
    );
    hiddenCards.forEach((el) => {
      el.removeAttribute('hidden');
      el.classList.remove('m-home-product-card--collapsed');
    });
    button.setAttribute('aria-expanded', 'true');
    setButtonText(true);
  };

  // 初期テキストを同期（サーバーマークアップと齟齬がないように）
  setButtonText(button.getAttribute('aria-expanded') === 'true');

  button.addEventListener('click', () => {
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    if (isExpanded) {
      collapseToInitial();
    } else {
      expandAll();
    }
  });
}
